import { memo } from 'react'

import { ContentCopy } from '@mui/icons-material'
import { ListItemIcon, MenuItem, MenuItemProps } from '@mui/material'
import { useSnackbar } from 'notistack'
import CopyToClipboard from 'react-copy-to-clipboard'
import { useTranslation } from 'react-i18next'

type MenuItemCopyIdProps = {
  id: string
  staticLabel?: string
  onSuccess?: () => void
} & MenuItemProps

const MenuItemCopyIdRaw = ({ staticLabel, id, onSuccess, ...menuItemProps }: MenuItemCopyIdProps) => {
  const { t } = useTranslation()
  const { enqueueSnackbar } = useSnackbar()

  return (
    <CopyToClipboard
      text={id}
      onCopy={() => {
        enqueueSnackbar(t('copiedToClipboard'), {
          variant: 'info',
        })

        onSuccess?.()
      }}
    >
      <MenuItem {...menuItemProps}>
        <ListItemIcon>
          <ContentCopy />
        </ListItemIcon>
        {staticLabel || t('copyId')}
      </MenuItem>
    </CopyToClipboard>
  )
}

export const MenuItemCopyId = memo(MenuItemCopyIdRaw)
